import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import P11AdminLayout from "./P11AdminLayout";
import { P11, fmtDate } from "./p11shared";

// Admin-home: prioriteit aan de eerstvolgende training + directe aanwezigheidslink.
export default function P11AdminHome() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/project11/admin/overview").then(({ data }) => setData(data)).catch(() => setData(false)); }, []);
  if (data === null) return <P11AdminLayout><span className="p11-label">…</span></P11AdminLayout>;
  if (data === false) return <P11AdminLayout><span className="p11-label" data-testid="p11-admin-error">Laden mislukt.</span></P11AdminLayout>;
  const s = data.next_session;
  return (
    <P11AdminLayout>
      <div data-testid="p11-admin-home">
        <div className="p11-label-yellow">PROJECT 11* / {data.edition.id}</div>
        <h1 className="p11-h1 text-3xl mt-4 mb-10">{s ? "NEXT SESSION." : "GEEN SESSIES MEER."}</h1>
        {s && (
          <Link to={`/project11/admin/sessions/${s.id}`} className="block border p-8 hover:border-[#FFE44D] transition-colors" style={{ borderColor: P11.border }} data-testid="p11-admin-next-session">
            <div className="p11-label">{fmtDate(s.date)} · {s.start_time}–{s.end_time}</div>
            <div className="p11-h1 text-5xl mt-4" style={{ color: P11.yellow }}>SESSIE {String(s.number).padStart(2, "0")}</div>
            <div className="p11-label mt-4">{s.location}</div>
            <div className="p11-label mt-6" style={{ color: P11.yellow }}>AANWEIGHEID REGISTREREN →</div>
          </Link>
        )}
        <div className="grid grid-cols-2 gap-3 mt-8">
          <Link to="/project11/admin/participants" className="p11-btn-ghost justify-center" data-testid="p11-admin-home-participants">PARTICIPANTS</Link>
          <Link to="/project11/admin/overview" className="p11-btn-ghost justify-center" data-testid="p11-admin-home-overview">OVERVIEW</Link>
        </div>
      </div>
    </P11AdminLayout>
  );
}
